module.exports = "<div class=\"hint\">\n  يجب ان يكون رابط ملف الصوت صالح\n</div>\n"